module.exports = __webpack_public_path__ + "static/cliente_6-3e8180daef4cfef938a3112e557bbf84.png";